// extracted by mini-css-extract-plugin
export var root = "X_yn";
export var wrapper = "X_r2";
export var image = "X_vw d_w d_y d_W";
export var imageWithHeight = "X_yp";
export var crop = "X_yq";
export var round = "X_yr";
export var fixedHeight = "X_ys";